module.exports = __webpack_public_path__ + "img/login.358722b8.svg";